import { useIntl } from '@weenat/wintl';
const PAYMENT_STEP_IDS = [
    'choose_subscription',
    'billing_information',
    'redirect_to_payment'
];
export function usePaymentSteps(step) {
    const { t } = useIntl();
    const currentStepNumber = PAYMENT_STEP_IDS.findIndex((current) => current === step) + 1;
    const titlePerSteps = {
        choose_subscription: t('ecommerce.plans.journey.choose_plan', { capitalize: true }),
        billing_information: t('ecommerce.plans.journey.setup_billing_account', { capitalize: true }),
        redirect_to_payment: t('ecommerce.plans.journey.redirect_to_payment', { capitalize: true })
    };
    const stepName = titlePerSteps[step];
    return {
        steps: PAYMENT_STEP_IDS,
        stepName,
        titlePerSteps,
        currentStepNumber
    };
}
